/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, suffix: NonNullable<unknown>, name: NonNullable<unknown> }} Explorer_Table_Move_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Moved {count} item{suffix} to \"{name}\"" |
*
* @param {Explorer_Table_Move_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_move_success_toast = /** @type {((inputs: Explorer_Table_Move_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Move_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Deplace ${i?.count} element${i?.suffix} vers "${i?.name}"`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} item${i?.suffix} nach "${i?.name}" verschoben`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Spostato ${i?.count} elemento${i?.suffix} in "${i?.name}"`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Перемещен элемент ${i?.count}${i?.suffix} в "${i?.name}"`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se movió el elemento ${i?.count} a "${i?.name}"`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`将 ${i?.count} 项目 ${i?.suffix} 移动到“${i?.name}”`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} アイテム${i?.suffix} を "${i?.name}" に移動しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} आइटम${i?.suffix} को "${i?.name}" में स्थानांतरित किया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O item ${i?.count} foi movido para "${i?.name}".`)
	return /** @type {LocalizedString} */ (`Moved ${i?.count} item${i?.suffix} to "${i?.name}"`)
});